import React, { Fragment } from "react"
import { useTable } from "react-table"
import { Table } from "reactstrap"

const ActivityLogTable = ({
  columns,
  data,
  isMobile,
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    rows,
  } = useTable({
    columns,
    data,
    initialState: {},
  })

  const generateSortingIndicator = column => {
    return column.isSorted ? (
      column.isSortedDesc ? (
        <i className="bx bx-sort-down"></i>
      ) : (
        <i className="bx bx-sort-up"></i>
      )
    ) : (
      ""
    )
  }

  return (
    <>
      <Table {...getTableProps()} bordered responsive>
        <thead>
          {headerGroups.map(headerGroup => (
            <tr
              key={headerGroup.id}
              {...headerGroup.getHeaderGroupProps()}
              className="table-light"
            >
              {headerGroup.headers.map(column => (
                <th
                  key={column.id}
                  style={{
                    width: column.width || 'auto',
                    minWidth: column.minWidth || 'auto'
                  }}
                >
                  <div className="mb-2">
                    {column.render("Header")}
                    {generateSortingIndicator(column)}
                  </div>
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {(rows?.length > 0 &&
            rows.map(row => {
              prepareRow(row)
              return (
                <Fragment key={row.getRowProps().key}>
                  <tr {...row.getRowProps()}>
                    {row.cells.map(cell => {
                      return (
                        <td
                          key={cell.id}
                          {...cell.getCellProps()}
                          data-label={cell?.column?.Header}
                          style={{
                            width: cell.column.width || 'auto',
                            minWidth: cell.column.minWidth || 'auto'
                          }}
                        >
                          {cell.render("Cell")}
                        </td>
                      )
                    })}
                  </tr>
                </Fragment>
              )
            })) || (
            <tr>
              {!isMobile ? (
                <td
                  colSpan={"5"}
                  className="react-bs-table-no-data text-center"
                >
                  Sorry, There are no data to display
                </td>
              ) : (
                <div className="table-info text-center">
                  <span>Sorry, There are no data to display</span>
                </div>
              )}
            </tr>
          )}
        </tbody>
      </Table>
    </>
  )
}

export default ActivityLogTable
